<template>
  <div :class="$style.container">
    <div v-if="isLate" :class="$style.loader">
      <div>Запрос выполняется, еще немного...</div>
      <div :class="$style.popup">
        <div :class="$style.ldsEllipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLate: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLate = true;
    }, 5000);
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  // background-color: $bg-separator;
  backdrop-filter: blur(0.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  //color: $t-white;
  font-size: 1.5rem;
  .loader {
    text-align: center;
    user-select: none;
    //background-color: $bg-main;
    pointer-events: none;
    padding: 3rem;
    border-radius: 2rem;
    @include custom(482) {
      padding: 1rem;
    }
  }
}
.popup {
  display: flex;
  justify-content: center;
  align-items: center;

  .ldsEllipsis,
  .ldsEllipsis div {
    box-sizing: border-box;
  }
  .ldsEllipsis {
    display: inline-block;
    position: relative;
    width: 6rem;
    height: 3.5rem;
  }
  .ldsEllipsis div {
    position: absolute;
    top: 33.33333px;
    width: 13.33333px;
    height: 13.33333px;
    border-radius: 50%;
    background: blue;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .ldsEllipsis div:nth-child(1) {
    left: 8px;
    animation: ldsEllipsis1 0.9s infinite;
  }
  .ldsEllipsis div:nth-child(2) {
    left: 8px;
    animation: ldsEllipsis2 0.9s infinite; // синхронизация с уменьшением первого шара
  }
  .ldsEllipsis div:nth-child(3) {
    left: 32px;
    animation: ldsEllipsis2 0.9s infinite;
  }
  .ldsEllipsis div:nth-child(4) {
    left: 56px;
    animation: ldsEllipsis2 0.9s infinite;
  }
  .ldsEllipsis div:nth-child(5) {
    left: 80px;
    animation: ldsEllipsis3 0.9s infinite; // появление нового шара позже остальных
  }
  @keyframes ldsEllipsis1 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes ldsEllipsis3 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes ldsEllipsis2 {
    0% {
      transform: translate(24px, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }
}
</style>
